<template>
  <router-view />
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "@/assets/styles/tests.scss";
</style>
